/* eslint-disable */
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

// eslint-disable-next-line require-await
export async function getWarrantyUrlFromApi(): Promise<any> {
    const warrantyUrl = await get<any>(`api/v1/CustomRma/GetWarrantyUrl`, {} as ApiParameter);
    return warrantyUrl;
}
